var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "ita-index-container" },
    [
      _vm.getUser.userType == "1"
        ? _c("div", { staticClass: "btn-row" }, [
            _c(
              "div",
              { staticClass: "status" },
              _vm._l(_vm.statusOptions, function (v, k) {
                return _c("div", { key: k, staticClass: "status-item" }, [
                  _c("img", {
                    staticClass: "status-icon",
                    attrs: { src: v.icon },
                  }),
                  _c("div", { staticClass: "status-text" }, [
                    _vm._v(_vm._s(_vm.$t(v.label))),
                  ]),
                ])
              }),
              0
            ),
            _c(
              "div",
              { staticClass: "btns" },
              [
                _c(
                  "el-button",
                  { staticClass: "wl-green", on: { click: _vm.onAddClick } },
                  [
                    _c("i", { staticClass: "el-icon-plus" }),
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("ita_add_qa")) +
                        "\n            "
                    ),
                  ]
                ),
                _c(
                  "el-button",
                  {
                    staticClass: "wl-green",
                    attrs: { disabled: _vm.chooseable },
                    on: { click: _vm.HandleNotifyClientClick },
                  },
                  [
                    _c("img", { attrs: { src: _vm.exportIcon } }),
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("ita_btn_notify_client")) +
                        "\n            "
                    ),
                  ]
                ),
                _c(
                  "el-button",
                  {
                    staticClass: "wl-green",
                    attrs: { disabled: _vm.chooseable },
                    on: { click: _vm.HandleArchiveQuestionnaireClick },
                  },
                  [
                    _c("img", { attrs: { src: _vm.exportIcon } }),
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("ita_btn_archive_questionnaire")) +
                        "\n            "
                    ),
                  ]
                ),
              ],
              1
            ),
          ])
        : _vm._e(),
      _c(
        "div",
        { staticClass: "table" },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              ref: "itaTable",
              attrs: {
                border: "",
                height: "100%",
                data: _vm.list,
                "span-method": _vm.objectSpanMethod,
              },
              on: { "selection-change": _vm.onTableSelectChange },
            },
            [
              _vm.getUser.userType == "1" && _vm.chooseable
                ? _c("el-table-column", {
                    attrs: {
                      align: "center",
                      type: "selection",
                      width: "50",
                      resizable: "",
                      "class-name": "border-bottom",
                    },
                  })
                : _vm._e(),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("TABLE_HEAD_EntityList"),
                  prop: "entityName",
                  "header-align": "center",
                  resizable: "",
                  "show-overflow-tooltip": "",
                  "class-name": "border-bottom",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  width: "150",
                  "header-align": "center",
                  resizable: "",
                  "show-overflow-tooltip": "",
                },
                scopedSlots: _vm._u([
                  {
                    key: "header",
                    fn: function () {
                      return [
                        _c(
                          "div",
                          { staticClass: "table-header" },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.$t("ita_table_header_section")) +
                                "\n                        "
                            ),
                            _c("MultiSelectPopver", {
                              attrs: {
                                hidePopperSearch: _vm.getList,
                                value: _vm.search.section,
                                labelKey: "sectionI18n",
                                valueKey: "id",
                                inputFilterKey: ["sectionI18n", "id"],
                                options: _vm.displaySectionOptions,
                                iconColor: "#3879eb",
                                iconSize: "15",
                              },
                              on: {
                                "update:value": function ($event) {
                                  return _vm.$set(_vm.search, "section", $event)
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                  {
                    key: "default",
                    fn: function (scope) {
                      return _c(
                        "div",
                        {
                          staticClass: "table-cell table-cell-section",
                          on: {
                            click: function ($event) {
                              return _vm.onSectionClick(scope.row)
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(
                                _vm.$i18n.locale == "zh"
                                  ? scope.row.sectionNameCn
                                  : scope.row.sectionName
                              ) +
                              "\n                "
                          ),
                        ]
                      )
                    },
                  },
                ]),
              }),
              _c(
                "el-table-column",
                {
                  attrs: {
                    width: "150",
                    align: "center",
                    "header-align": "center",
                    resizable: "",
                    "show-overflow-tooltip": "",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return _c(
                          "div",
                          { staticClass: "table-cell" },
                          [
                            _vm.getUser.userType == "1"
                              ? _c(
                                  "el-dropdown",
                                  {
                                    on: {
                                      command: (v) =>
                                        _vm.onSingleUpdate(
                                          "status",
                                          v,
                                          scope.row
                                        ),
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "status-dropdown-item" },
                                      [
                                        _c("img", {
                                          attrs: {
                                            src: _vm.statusValueToIcon(
                                              scope.row.status
                                            ),
                                          },
                                        }),
                                        _c(
                                          "span",
                                          {
                                            staticClass: "text",
                                            style: {
                                              color: _vm.statusValueToColor(
                                                scope.row.status
                                              ),
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.statusValueToLabel(
                                                  scope.row.status
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                        _c("i", {
                                          staticClass: "el-icon-caret-bottom",
                                        }),
                                      ]
                                    ),
                                    _c(
                                      "el-dropdown-menu",
                                      {
                                        attrs: { slot: "dropdown" },
                                        slot: "dropdown",
                                      },
                                      _vm._l(_vm.statusOptions, function (v) {
                                        return _c(
                                          "el-dropdown-item",
                                          {
                                            key: v.value,
                                            staticStyle: {
                                              "font-size": "12px",
                                            },
                                            attrs: {
                                              command: v.value,
                                              value: v.value,
                                            },
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "status-dropdown-item",
                                              },
                                              [
                                                _c("img", {
                                                  attrs: { src: v.icon },
                                                }),
                                                _vm._v(
                                                  "\n                                    " +
                                                    _vm._s(_vm.$t(v.label)) +
                                                    "\n                                "
                                                ),
                                              ]
                                            ),
                                          ]
                                        )
                                      }),
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _c(
                                  "span",
                                  {
                                    staticClass:
                                      "status-dropdown-item status-dropdown-item-inactive",
                                  },
                                  [
                                    _c("img", {
                                      attrs: {
                                        src: _vm.statusValueToIcon(
                                          scope.row.status
                                        ),
                                      },
                                    }),
                                    _c(
                                      "span",
                                      {
                                        staticClass: "text",
                                        style: {
                                          color: _vm.statusValueToColor(
                                            scope.row.status
                                          ),
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.statusValueToLabel(
                                              scope.row.status
                                            )
                                          )
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                          ],
                          1
                        )
                      },
                    },
                  ]),
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "table-header",
                      attrs: { slot: "header" },
                      slot: "header",
                    },
                    [
                      _vm.getUser.userType == "1"
                        ? _c(
                            "el-dropdown",
                            {
                              staticStyle: { "margin-right": "5px" },
                              on: {
                                command: (v) => _vm.onBatchUpdate("status", v),
                              },
                            },
                            [
                              _c("span", { staticClass: "el-dropdown-link" }, [
                                _c("i", {
                                  staticClass:
                                    "el-icon-edit-outline table-header-edit-cls table-header-blue-icon",
                                }),
                              ]),
                              _c(
                                "el-dropdown-menu",
                                {
                                  attrs: { slot: "dropdown" },
                                  slot: "dropdown",
                                },
                                _vm._l(_vm.statusOptions, function (v) {
                                  return _c(
                                    "el-dropdown-item",
                                    {
                                      key: v.value,
                                      staticStyle: { "font-size": "12px" },
                                      attrs: {
                                        command: v.value,
                                        value: v.value,
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "status-dropdown-item" },
                                        [
                                          _c("img", { attrs: { src: v.icon } }),
                                          _vm._v(
                                            "\n                                    " +
                                              _vm._s(_vm.$t(v.label)) +
                                              "\n                                "
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                }),
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.$t("ita_table_header_status")) +
                          "\n                    "
                      ),
                      _c("MultiSelectPopver", {
                        attrs: {
                          hidePopperSearch: _vm.getList,
                          value: _vm.search.status,
                          labelKey: "xlabel",
                          valueKey: "value",
                          inputFilterKey: ["xlabel", "value"],
                          options: _vm.statusOptions.map((v) => ({
                            xlabel: _vm.$t(v.label),
                            ...v,
                          })),
                          iconColor: "#3879eb",
                          iconSize: "15",
                        },
                        on: {
                          "update:value": function ($event) {
                            return _vm.$set(_vm.search, "status", $event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ]
              ),
              _c("el-table-column", {
                attrs: {
                  width: "250",
                  align: "center",
                  "header-align": "center",
                  resizable: "",
                  "show-overflow-tooltip": "",
                },
                scopedSlots: _vm._u([
                  {
                    key: "header",
                    fn: function (scope) {
                      return [
                        _c(
                          "div",
                          { staticClass: "table-header" },
                          [
                            _c(
                              "el-dropdown",
                              {
                                staticStyle: { "margin-right": "5px" },
                                attrs: { trigger: "click" },
                                on: {
                                  command: (v) =>
                                    _vm.onBatchUpdate("clientResponsible", v),
                                },
                              },
                              [
                                _c(
                                  "span",
                                  { staticClass: "el-dropdown-link" },
                                  [
                                    _c("i", {
                                      staticClass:
                                        "el-icon-edit-outline table-header-edit-cls table-header-blue-icon",
                                    }),
                                  ]
                                ),
                                _c(
                                  "el-dropdown-menu",
                                  {
                                    attrs: { slot: "dropdown" },
                                    slot: "dropdown",
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        size: "mini",
                                        placeholder: _vm.$t(
                                          "ita_table_header_client_responsible"
                                        ),
                                        clearable: "",
                                      },
                                      model: {
                                        value: _vm.clientOwnerFilterInput,
                                        callback: function ($$v) {
                                          _vm.clientOwnerFilterInput = $$v
                                        },
                                        expression: "clientOwnerFilterInput",
                                      },
                                    }),
                                    _vm._l(
                                      _vm.displayClientOwnerList,
                                      function (v) {
                                        return _c(
                                          "el-dropdown-item",
                                          {
                                            key: v.id,
                                            staticStyle: {
                                              "font-size": "12px",
                                            },
                                            attrs: {
                                              command: v.id,
                                              value: v.id,
                                            },
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "status-dropdown-item",
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(v.userName) +
                                                    "(" +
                                                    _vm._s(v.email) +
                                                    ") "
                                                ),
                                              ]
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                  ],
                                  2
                                ),
                              ],
                              1
                            ),
                            _vm._v(
                              "\n                        " +
                                _vm._s(
                                  _vm.$t("ita_table_header_client_responsible")
                                ) +
                                "\n                        "
                            ),
                            _c("MultiSelectPopver", {
                              attrs: {
                                hidePopperSearch: _vm.getList,
                                value: _vm.search.clientResponsible,
                                labelKey: "xlabel",
                                valueKey: "id",
                                inputFilterKey: [
                                  "id",
                                  "email",
                                  "userName",
                                  "xlabel",
                                ],
                                options: _vm.clientOwnerList.map((v) => ({
                                  xlabel: `${v.userName}(${v.email})`,
                                  ...v,
                                })),
                                iconColor: "#3879eb",
                                iconSize: "15",
                              },
                              on: {
                                "update:value": function ($event) {
                                  return _vm.$set(
                                    _vm.search,
                                    "clientResponsible",
                                    $event
                                  )
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                  {
                    key: "default",
                    fn: function (scope) {
                      return _c("div", { staticClass: "table-cell" }, [
                        _c("span", { staticClass: "status-dropdown-item" }, [
                          _c("span", { staticClass: "text" }, [
                            _vm._v(
                              "\n                            " +
                                _vm._s(
                                  scope.row.clientOwnerList.find(
                                    (v) => v.id == scope.row.clientResponsible
                                  )
                                    ? scope.row.clientOwnerList.find(
                                        (v) =>
                                          v.id == scope.row.clientResponsible
                                      ).userName +
                                        `(${
                                          scope.row.clientOwnerList.find(
                                            (v) =>
                                              v.id ==
                                              scope.row.clientResponsible
                                          ).email
                                        })`
                                    : ""
                                ) +
                                "\n                        "
                            ),
                          ]),
                          _c("i", {
                            staticClass: "el-icon-edit table-header-blue-icon",
                            on: {
                              click: function ($event) {
                                return _vm.onUpdateClientClick(scope.row)
                              },
                            },
                          }),
                        ]),
                      ])
                    },
                  },
                ]),
              }),
              _c(
                "el-table-column",
                {
                  attrs: {
                    width: "180",
                    align: "center",
                    "header-align": "center",
                    resizable: "",
                    "show-overflow-tooltip": "",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return _c(
                          "div",
                          { staticClass: "table-cell" },
                          [
                            _vm._v(
                              "\n                    " +
                                _vm._s(
                                  _vm._f("formatDate")(scope.row.periodEndDate)
                                ) +
                                "\n                    "
                            ),
                            _vm.getUser.userType == "1"
                              ? _c(
                                  "DatePickerPopover",
                                  {
                                    attrs: {
                                      rangeSelect: false,
                                      hidePopperSearch: (e) =>
                                        _vm.onSingleUpdate(
                                          "periodEndDate",
                                          e,
                                          scope.row
                                        ),
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass:
                                        "el-icon-edit table-header-blue-icon",
                                      attrs: { slot: "icon" },
                                      slot: "icon",
                                    }),
                                  ]
                                )
                              : _vm._e(),
                          ],
                          1
                        )
                      },
                    },
                  ]),
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "table-header",
                      attrs: { slot: "header" },
                      slot: "header",
                    },
                    [
                      _vm.getUser.userType == "1"
                        ? _c(
                            "DatePickerPopover",
                            {
                              staticStyle: { "margin-right": "5px" },
                              attrs: {
                                rangeSelect: false,
                                value: _vm.patchEditPeriodDate,
                                hidePopperSearch: (e) =>
                                  _vm.onBatchUpdate("periodEndDate", e),
                              },
                              on: {
                                "update:value": function ($event) {
                                  _vm.patchEditPeriodDate = $event
                                },
                              },
                            },
                            [
                              _c("i", {
                                staticClass:
                                  "el-icon-edit-outline table-header-edit-cls table-header-blue-icon",
                                attrs: { slot: "icon" },
                                slot: "icon",
                              }),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.$t("ita_table_header_period_date")) +
                          "\n                    "
                      ),
                      _c("DatePickerPopover", {
                        attrs: {
                          hidePopperSearch: _vm.getList,
                          value: _vm.search.periodDate,
                        },
                        on: {
                          "update:value": function ($event) {
                            return _vm.$set(_vm.search, "periodDate", $event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ]
              ),
              _c(
                "el-table-column",
                {
                  attrs: {
                    width: "180",
                    align: "center",
                    "header-align": "center",
                    "show-overflow-tooltip": "",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return _c(
                          "div",
                          { staticClass: "table-cell" },
                          [
                            _vm._v(
                              "\n                    " +
                                _vm._s(
                                  _vm._f("formatDate")(scope.row.dueDate)
                                ) +
                                "\n                    "
                            ),
                            _vm.getUser.userType == "1"
                              ? _c(
                                  "DatePickerPopover",
                                  {
                                    attrs: {
                                      rangeSelect: false,
                                      hidePopperSearch: (e) =>
                                        _vm.onSingleUpdate(
                                          "dueDate",
                                          e,
                                          scope.row
                                        ),
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass:
                                        "el-icon-edit table-header-blue-icon",
                                      attrs: { slot: "icon" },
                                      slot: "icon",
                                    }),
                                  ]
                                )
                              : _vm._e(),
                          ],
                          1
                        )
                      },
                    },
                  ]),
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "table-header",
                      attrs: { slot: "header" },
                      slot: "header",
                    },
                    [
                      _vm.getUser.userType == "1"
                        ? _c(
                            "DatePickerPopover",
                            {
                              staticStyle: { "margin-right": "5px" },
                              attrs: {
                                rangeSelect: false,
                                value: _vm.patchDueDate,
                                hidePopperSearch: (e) =>
                                  _vm.onBatchUpdate("dueDate", e),
                              },
                              on: {
                                "update:value": function ($event) {
                                  _vm.patchDueDate = $event
                                },
                              },
                            },
                            [
                              _c("i", {
                                staticClass:
                                  "el-icon-edit-outline table-header-edit-cls table-header-blue-icon",
                                attrs: { slot: "icon" },
                                slot: "icon",
                              }),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.$t("ita_table_header_due_date")) +
                          "\n                    "
                      ),
                      _c("DatePickerPopover", {
                        attrs: {
                          hidePopperSearch: _vm.getList,
                          value: _vm.search.dueDate,
                        },
                        on: {
                          "update:value": function ($event) {
                            return _vm.$set(_vm.search, "dueDate", $event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ]
              ),
              _c(
                "el-table-column",
                {
                  attrs: {
                    width: "150",
                    align: "center",
                    "header-align": "center",
                    resizable: "",
                    "show-overflow-tooltip": "",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _vm._v(
                            "\n                    " +
                              _vm._s(scope.row.updateUser) +
                              "\n                "
                          ),
                        ]
                      },
                    },
                  ]),
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "table-header",
                      attrs: { slot: "header" },
                      slot: "header",
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.$t("ita_table_header_last_update_by")) +
                          "\n                    "
                      ),
                      _c("MultiSelectPopver", {
                        attrs: {
                          hidePopperSearch: _vm.getList,
                          value: _vm.search.lastUpdateBy,
                          labelKey: "xlabel",
                          valueKey: "xid",
                          inputFilterKey: ["xid", "xlabel"],
                          options: _vm.lastUpdateByOptions,
                          iconColor: "#3879eb",
                          iconSize: "15",
                        },
                        on: {
                          "update:value": function ($event) {
                            return _vm.$set(_vm.search, "lastUpdateBy", $event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ]
              ),
              _c("el-table-column", {
                attrs: {
                  width: "150",
                  align: "center",
                  "header-align": "center",
                  label: _vm.$t("ita_table_header_last_update_time"),
                  resizable: "",
                  "show-overflow-tooltip": "",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n                    " +
                            _vm._s(
                              _vm._f("formatDateTime")(scope.row.updateDate)
                            ) +
                            "\n                "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm.getUser.userType == "1"
                ? _c("el-table-column", {
                    attrs: {
                      width: "150",
                      align: "center",
                      "header-align": "center",
                      label: _vm.$t("ita_table_header_delete"),
                      resizable: "",
                      "class-name": "border-bottom",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return _c(
                              "div",
                              {
                                staticClass: "table-cell table-cell-delete",
                                on: {
                                  click: function ($event) {
                                    return _vm.onDeleteClick(scope.row)
                                  },
                                },
                              },
                              [_c("i", { staticClass: "el-icon-delete" })]
                            )
                          },
                        },
                      ],
                      null,
                      false,
                      2090163794
                    ),
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _vm.chooseable
        ? _c(
            "div",
            { staticClass: "footer-btn" },
            [
              _c(
                "el-button",
                {
                  staticClass: "cancel-btn",
                  attrs: { disabled: !_vm.chooseable },
                  on: { click: _vm.cancelChoose },
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$t("btn_cancel")) +
                      "\n        "
                  ),
                ]
              ),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.multiChoose.mode == "email",
                      expression: "multiChoose.mode == 'email'",
                    },
                  ],
                  staticClass: "wl-green",
                  attrs: {
                    disabled:
                      _vm.chooseable && _vm.tableSelectedRows.length == 0,
                  },
                  on: { click: _vm.onNotifyClientClick },
                },
                [
                  _c("img", { attrs: { src: _vm.exportIcon } }),
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$t("ita_btn_notify_client")) +
                      "\n        "
                  ),
                ]
              ),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.multiChoose.mode == "questionnaire",
                      expression: "multiChoose.mode == 'questionnaire'",
                    },
                  ],
                  staticClass: "wl-green",
                  attrs: {
                    disabled:
                      _vm.chooseable && _vm.tableSelectedRows.length == 0,
                  },
                  on: { click: _vm.onArchiveQuestionnaireClick },
                },
                [
                  _c("img", { attrs: { src: _vm.exportIcon } }),
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$t("ita_btn_archive_questionnaire")) +
                      "\n        "
                  ),
                ]
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "el-pagination",
        {
          staticClass: "wl-pagination",
          attrs: {
            "current-page": _vm.page,
            "page-size": _vm.limit,
            layout: "prev, pager, next, slot, total",
            total: _vm.total,
          },
          on: {
            "update:currentPage": function ($event) {
              _vm.page = $event
            },
            "update:current-page": function ($event) {
              _vm.page = $event
            },
            "update:pageSize": function ($event) {
              _vm.limit = $event
            },
            "update:page-size": function ($event) {
              _vm.limit = $event
            },
            "current-change": _vm.onCurrentPageChange,
            "size-change": _vm.onSizeChange,
          },
        },
        [
          _c(
            "span",
            [
              _c(
                "el-select",
                {
                  on: { change: _vm.onSizeChange },
                  model: {
                    value: _vm.limit,
                    callback: function ($$v) {
                      _vm.limit = $$v
                    },
                    expression: "limit",
                  },
                },
                _vm._l(_vm.pageOptions, function (item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.label, value: item.value },
                  })
                }),
                1
              ),
            ],
            1
          ),
        ]
      ),
      _c("addQuestionnaire", {
        attrs: {
          show: _vm.add.show,
          bindData: _vm.add.data,
          handleSave: _vm.onAddCommit,
        },
        on: {
          "update:show": function ($event) {
            return _vm.$set(_vm.add, "show", $event)
          },
          "update:bindData": function ($event) {
            return _vm.$set(_vm.add, "data", $event)
          },
          "update:bind-data": function ($event) {
            return _vm.$set(_vm.add, "data", $event)
          },
        },
      }),
      _c("noticeUndone", {
        attrs: {
          show: _vm.showNoticeUndone,
          summaryList: _vm.noticeUndoneSummaryList,
        },
        on: {
          "update:show": function ($event) {
            _vm.showNoticeUndone = $event
          },
        },
      }),
      _c("updateClientResponsible", {
        attrs: {
          show: _vm.updateClientResponsible.show,
          options: _vm.updateClientResponsible.options,
          onConfirm: _vm.confirmUpdateClientResponsible,
          value: _vm.updateClientResponsible.value,
        },
        on: {
          "update:show": function ($event) {
            return _vm.$set(_vm.updateClientResponsible, "show", $event)
          },
          "update:value": function ($event) {
            return _vm.$set(_vm.updateClientResponsible, "value", $event)
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }